<template>
    <b-modal
        :hide-footer="true"
        :title="$t('Mais informações do Cad Único')"
        centered
        size="xl"
        id="mais-info"
    >
        <div class="row">
            <div class="col-md-12">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                Data da entrevista:
                                {{ $parent.item.data_entrevista }}
                            </th>
                            <th>
                                Nome do entrevistador:
                                {{ $parent.item.nome_entrevistador }}
                            </th>
                            <th>
                                CPF do entrevistador:
                                {{ $parent.item.cpf_entrevistador }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="2">
                                <p>Atualização cadastral via APP</p>
                                <strong>{{ motivoAtualizacaoCidadao }}</strong>
                            </td>
                            <td>
                                <p>Finalização do cadastro</p>
                                <b-badge
                                    v-if="item.ind_cad_familia_finalizado === 1"
                                    variant="success"
                                    title="Famílias com cadastro finalizado não podem ser excluídas fisicamente."
                                >Cadastro Finalizado</b-badge>
                                <b-badge
                                    v-else-if="item.ind_cad_familia_finalizado === 0"
                                    variant="warning"
                                >Cadastro Não Finalizado</b-badge>
                                <strong v-else>Não informado</strong>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <p>Observação apontadas pelo entrevistador</p>
                                {{ $parent.item.observacoes }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["item"],
    computed: {
        motivoAtualizacaoCidadao() {
            const motivos = {
                1: "Exclusão por indicativo de óbito",
                2: "Inclusão por indicativo de nascimento",
            };
            return motivos[this.item.cod_mot_atualizacao_cidadao] || "Não informado";
        },
    },
    data() {
        return {};
    },
    methods: {
        submit() {},
    },
};
</script>
